import * as config from "./../config/config";
import api from "./interceptor";

export async function create_commande(facture_id, data) {
  try {
    const response = await api.post(
      config.REACT_APP_ENDPOINT_CREATE_COMMANDE, {
      "data": JSON.stringify(data),
      'facture_id': facture_id,
      "user_id": localStorage.getItem('user_id'),
      "type": "new"
    }
    )
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function create_additionnal_commande(data) {
  try {
    const response = await api.post(
      config.REACT_APP_ENDPOINT_CREATE_COMMANDE_ADDITIONAL, {
      "data": JSON.stringify(data),
      'facture_id': JSON.stringify(data).facture_id,
      'camion_id': JSON.stringify(data).camions,
      "user_id": localStorage.getItem('user_id'),
      "type": "additionnal"

    }
    )
    return response.data;
  } catch (error) {
    throw error;
  }
}


export async function getall_commandes({ start, end } = {}) {
  try {
    const params = {};
    if (start) params.start = start;
    if (end) params.end = end;

    const response = await api.get(config.REACT_APP_ENDPOINT_LISTE_COMMANDE, {
      params,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function get_commande(commande_id) {
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_GET_COMMANDE + commande_id);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function downloadCommande(commande_id) {
  try {
    const response = await api.post(
      config.REACT_APP_ENDPOINT_DOWNLOAD_COMMANDE + commande_id,
      {}, // <- pas de body à envoyer ici
      { responseType: "blob" } // ✅ c’est ici qu’on met le responseType
    );

    // 🔽 Créer un blob PDF à partir des données reçues
    const blob = new Blob([response.data], { type: "application/pdf" });

    // Récupérer le nom du fichier depuis les headers si dispo
    const contentDisposition = response.headers["content-disposition"];
    let fileName = "devis.pdf";
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) fileName = match[1];
    }

    // 🔽 Créer et déclencher le téléchargement
    const link = document.createElement("a");
    const url = window.URL.createObjectURL(blob);
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    // Nettoyage
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("❌ Erreur lors du téléchargement du devis :", error);
    throw error;
  }
}

export async function update_commande(commandes) {
  try {
    const response = await api.put(
      config.REACT_APP_ENDPOINT_UPDATE_COMMANDE + commandes.commande_id, {
      "data": JSON.stringify(commandes)
    }
    )
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function toggle_commande(commande_id, statut_commande) {
  try {
    const response = await api.post(
      config.REACT_APP_ENDPOINT_TOGGLE_COMMANDE + commande_id,
      {
        statut_commande: statut_commande,
        user_id: localStorage.getItem('user_id')
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function export_commandes(params) {
  try {
    const response = await api.get(
      `${config.REACT_APP_ENDPOINT_EXPORT_COMMANDE}?${params.toString()}`,
      { responseType: "blob" }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `COMMANDE_export.xlsx`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
    return 1
  } catch (error) {
    throw error;
    return 0
  }
}